import { useMutation } from '@apollo/client';
import { useRef } from 'react';
import { RNPToastHelper } from '../../RNPToaster';
import {
  DELETE_CUSTOM_ROLE,
  DeleteCustomRoleResponse,
} from '../../../../apollo/queries/v3/RolesNPermissions/deleteCustomRole.queries';
import { OnDeleteArgs } from '../../RNPTable/RNPActions/context';

type Props = {
  onComplete: () => void;
};

type ReturnType = [(role: OnDeleteArgs) => void];

const useDeleteCustomRoleAPI = ({ onComplete }: Props): ReturnType => {
  const roleName = useRef('');
  const [deleteCustomRole] = useMutation(DELETE_CUSTOM_ROLE, {
    onCompleted: (res: DeleteCustomRoleResponse) => {
      if (res.deleteCustomRole) {
        onComplete();
        RNPToastHelper.deleteCustomRoleSuccess({
          roleName: roleName.current,
        });
      }
    },
    onError: (e) => {
      RNPToastHelper.error();
    },
  });

  const deleteRole = (role: OnDeleteArgs) => {
    roleName.current = role.roleName;
    const options = {
      variables: {
        input: {
          id: role.roleId,
        },
      },
    };
    deleteCustomRole(options);
  };

  return [deleteRole];
};

export default useDeleteCustomRoleAPI;
